import React from 'react';
import CloseButtonSvg from './CloseButtonSvg.component';
import MarketingButton from './MarketingButton.component';

const MarketingBanner = ({
	campaign: {
		BackgroundColor,
		Height,
		ImageUrl,
		ShowPrimaryButton,
		PrimaryButtonColor,
		PrimaryButtonHoverColor,
		PrimaryButtonText,
		PrimaryButtonTextColor,
		CloseButtonColor,
		CloseButtonHoverColor,
		HideCloseButton,
	},
	triggerCampaignAction,
}) => (
	<div
		className="common-marketing marketing-banner"
		style={{
			backgroundColor: BackgroundColor,
			width: '100%',
			height: Height,
		}}
	>
		{/* These container div layers are necessary for the CSS behavior to meet Product requirements */}
		<div className="image-button-container">
			<div className="image-container">
				<img
					className="banner-image"
					src={ImageUrl}
					style={{
						backgroundImage: ImageUrl,
					}}
					alt="marketing banner"
				/>
			</div>
			{ShowPrimaryButton && (
				<MarketingButton
					buttonType="primary"
					buttonColor={PrimaryButtonColor}
					buttonHoverColor={PrimaryButtonHoverColor}
					buttonText={PrimaryButtonText}
					buttonTextColor={PrimaryButtonTextColor}
					triggerCampaignAction={triggerCampaignAction}
				/>
			)}
		</div>
		{!HideCloseButton && (
			<CloseButtonSvg
				buttonColor={CloseButtonColor}
				buttonHoverColor={CloseButtonHoverColor}
				backgroundColor={BackgroundColor}
				triggerCampaignAction={triggerCampaignAction}
			/>
		)}
	</div>
);

export default MarketingBanner;
